(function() {
  var API_URL = 'https://raju-recipe-api.vercel.app/api/recipe';
  var selectedSauce = null;
  var conversationHistory = [];
  var isGenerating = false;

  // Sauce pills
  document.querySelectorAll('.rg-pill').forEach(function(pill) {
    pill.addEventListener('click', function() {
      document.querySelectorAll('.rg-pill').forEach(function(p) { p.classList.remove('active'); });
      if (selectedSauce === pill.dataset.sauce) {
        selectedSauce = null;
      } else {
        pill.classList.add('active');
        selectedSauce = pill.dataset.sauce;
      }
    });
  });

  // Quick prompts
  document.querySelectorAll('.rg-qp').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.getElementById('rg-input').value = btn.textContent;
      sendMessage();
    });
  });

  // Send button
  document.getElementById('rg-send-btn').addEventListener('click', sendMessage);
  document.getElementById('rg-input').addEventListener('keydown', function(e) {
    if (e.key === 'Enter') sendMessage();
  });

  function getSauceName() {
    var names = {
      mango: 'Mango & Scotch Bonnet',
      lime: 'Pickled Lime & Birdseye Chilli',
      bbq: 'Smokey BBQ Tamarind',
      surprise: 'any Raju sauce you think fits best'
    };
    return selectedSauce ? names[selectedSauce] : null;
  }

  function addMessage(text, role) {
    var messagesEl = document.getElementById('rg-messages');
    var div = document.createElement('div');
    div.className = 'rg-msg ' + role;
    if (role === 'assistant') {
      div.innerHTML = formatMarkdown(text);
    } else {
      div.textContent = text;
    }
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return div;
  }

  function showTyping() {
    var messagesEl = document.getElementById('rg-messages');
    var div = document.createElement('div');
    div.className = 'rg-typing';
    div.id = 'rg-typing';
    div.innerHTML = '<span></span><span></span><span></span>';
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function hideTyping() {
    var el = document.getElementById('rg-typing');
    if (el) el.remove();
  }

  function formatMarkdown(text) {
    return text
      .replace(/### (.+)/g, '<h3>$1</h3>')
      .replace(/## (.+)/g, '<h3>$1</h3>')
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/^\- (.+)/gm, '<li>$1</li>')
      .replace(/^\d+\. (.+)/gm, '<li>$1</li>')
      .replace(/(<li>[\s\S]*?<\/li>)/g, '<ul>$1</ul>')
      .replace(/\n\n/g, '</p><p>')
      .replace(/\n/g, '<br>');
  }

  function sendMessage() {
    if (isGenerating) return;
    var input = document.getElementById('rg-input');
    var text = input.value.trim();
    if (!text) return;

    input.value = '';
    isGenerating = true;
    document.getElementById('rg-send-btn').disabled = true;

    var userMessage = text;
    var sauce = getSauceName();
    if (sauce && conversationHistory.length === 0) {
      userMessage = "I'd like to use " + sauce + ". " + text;
    }

    addMessage(text, 'user');
    conversationHistory.push({ role: 'user', content: userMessage });
    showTyping();

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: conversationHistory, sauce: selectedSauce })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Failed to generate recipe');
      return response.json();
    })
    .then(function(data) {
      var assistantMessage = data.content || data.message || 'Sorry, something went wrong. Try again!';
      hideTyping();
      addMessage(assistantMessage, 'assistant');
      conversationHistory.push({ role: 'assistant', content: assistantMessage });
    })
    .catch(function(err) {
      hideTyping();
      addMessage("Oops! I couldn't connect right now. Try again in a moment.", 'assistant');
      console.error(err);
    })
    .finally(function() {
      isGenerating = false;
      document.getElementById('rg-send-btn').disabled = false;
      input.focus();
    });
  }
})();
